<spinner *ngIf="showSpinner">
</spinner>
